import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { VoiceWritingService, VoiceCommand, VoiceWritingState } from './../../services/voiceWriting.service';

@Component({
    selector: 'app-voice-writing',
    templateUrl: './voiceWriting.component.html',
    styleUrls: ['./voiceWriting.component.css'],
})


export class VoiceWritingComponent implements OnInit, OnDestroy {
  @ViewChild('observationsTextarea', { static: false }) observationsTextarea!: ElementRef;
  @ViewChild('treatmentTextarea', { static: false }) treatmentTextarea!: ElementRef;

  public voiceState: VoiceWritingState = {
    isListening: false,
    isActive: false,
    currentField: null,
    lastCommand: null,
    error: null
  };

  public isVoiceSupported = false;
  private subscriptions: Subscription[] = [];

  // Referencia al FormGroup del componente padre
  public toothStateForm!: FormGroup;

  constructor(private voiceWritingService: VoiceWritingService) {}

  ngOnInit(): void {
    this.isVoiceSupported = this.voiceWritingService.isVoiceWritingSupported();

    // Suscribirse al estado del servicio
    this.subscriptions.push(
      this.voiceWritingService.state$.subscribe(state => {
        this.voiceState = state;
        this.handleFieldFocus();
      })
    );


    // Suscribirse a los comandos ejecutados
    this.subscriptions.push(
      this.voiceWritingService.commandExecuted$.subscribe(command => {
        console.log("Entra subscriptions de commandExecuted$ de ngOnInit");
        this.handleVoiceCommand(command);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.voiceWritingService.stopVoiceWriting();
  }

  public toggleVoiceWriting(): void {
    if (this.voiceState.isActive) {
      this.voiceWritingService.stopVoiceWriting();
    } else {
      this.voiceWritingService.startVoiceWriting();
    }
  }

  private handleFieldFocus(): void
  {
    if (this.voiceState.currentField) {
      const textarea = this.getTextareaElement(this.voiceState.currentField);
      if (textarea) {
        setTimeout(() => {
          textarea.focus();
          textarea.classList.add('textarea-focused');

          // Remover la clase después de 2 segundos
          setTimeout(() => {
            textarea.classList.remove('textarea-focused');
          }, 2000);
        }, 100);
      }
    }
  }

  private handleVoiceCommand(command: VoiceCommand): void {
    switch (command.command) {
      case 'NAVIGATE':
        console.log("Entra a NAVIGATE de handleVoideCommand vW");
        this.navigateToField(command.targetField!);
        break;

      case 'APPEND_TEXT':
        this.appendTextToField(command.text!, command.targetField!);
        break;

      case 'DELETE':
        this.deleteFromField(command.targetField!);
        break;

      case 'CLEAR':
        this.clearField(command.targetField!);
        break;
    }
  }

  private navigateToField(fieldName: string): void {
    const textarea = this.getTextareaElement(fieldName);
    if (textarea) {
      textarea.focus();
      // Posicionar cursor al final
      const textLength = textarea.value.length;
      textarea.setSelectionRange(textLength, textLength);
    }
  }

  private appendTextToField(text: string, fieldName: string): void {
    if (!this.toothStateForm) return;

    const currentValue = this.toothStateForm.get(fieldName)?.value || '';
    const newValue = currentValue + (currentValue ? ' ' : '') + text;

    this.toothStateForm.get(fieldName)?.setValue(newValue);
    this.toothStateForm.get(fieldName)?.markAsTouched();

    // Actualizar el textarea visualmente
    const textarea = this.getTextareaElement(fieldName);
    if (textarea) {
      textarea.focus();
      // Posicionar cursor al final
      setTimeout(() => {
        const textLength = textarea.value.length;
        textarea.setSelectionRange(textLength, textLength);
      }, 10);
    }
  }

  private deleteFromField(fieldName: string): void {
    if (!this.toothStateForm) return;

    const currentValue = this.toothStateForm.get(fieldName)?.value || '';
    const words = currentValue.trim().split(' ');

    if (words.length > 1) {
      const newValue = words.slice(0, -1).join(' ');
      this.toothStateForm.get(fieldName)?.setValue(newValue);
    } else {
      this.toothStateForm.get(fieldName)?.setValue('');
    }

    this.toothStateForm.get(fieldName)?.markAsTouched();
  }

  private clearField(fieldName: string): void {
    if (!this.toothStateForm) return;

    this.toothStateForm.get(fieldName)?.setValue('');
    this.toothStateForm.get(fieldName)?.markAsTouched();
  }

  private getTextareaElement(fieldName: string): HTMLTextAreaElement | null {
    const selector = `textarea[formControlName="${fieldName}"]`;
    return document.querySelector(selector) as HTMLTextAreaElement;
  }

  public getFieldDisplayName(fieldName: string): string {
    const fieldNames: { [key: string]: string } = {
      'observations': 'Detalle',
      'treatment': 'Tratamiento'
    };

    return fieldNames[fieldName] || fieldName;
  }

  // Método para ser llamado desde el componente padre
  public setFormGroup(formGroup: FormGroup): void {
    this.toothStateForm = formGroup;
  }



}
